import TPESearchRequest, { DbSortOrder } from "src/models/common/TPESearchRequest";
import { OpenCalcReviewsSearchRequest } from "src/models/dashboard/OpenCalculationReview";
import DASHBOARD_CONSTANTS from "../dashboardConstants";

export function getTopOpenCalcReviewsSearchPayload(): OpenCalcReviewsSearchRequest {
    return {
        page: 1,
        pageSize: DASHBOARD_CONSTANTS.SMALL_PAGE_SIZE,
        sortField: DASHBOARD_CONSTANTS.OPEN_CALCULATION_REVIEW_FIELDS.DUE_DATE.DB_FIELD,
        sortOrder: DbSortOrder.ASCENDING,
        status: DASHBOARD_CONSTANTS.ACTIVE_STATUS
    };
}

export function getAllCalcReviewsSearchPayload(): OpenCalcReviewsSearchRequest {
    return {
        page: 1,
        pageSize: DASHBOARD_CONSTANTS.DEFAULT_PAGE_SIZE,
        sortField: DASHBOARD_CONSTANTS.OPEN_CALCULATION_REVIEW_FIELDS.DUE_DATE.DB_FIELD,
        sortOrder: DbSortOrder.ASCENDING,
    };
}